import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaCheck } from "react-icons/fa";

class Base extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this); 
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            zip_id: '',
            arquivo: '',
            zipHelper: '',
            erroLoadRegistro: "",
            titulo_pagina: "Base CRM",
            loading: false,
        };
    }

    componentDidMount(){
        
    }''

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            statusHelper: "",
        });

        const url = (this.state.zip_id) ? '/pessoas/crm/'+this.state.zip_id+'/' : '/pessoas/crm/'
        const metodo = (this.state.zip_id) ? 'put' : 'post'

        formData.append('arquivo', this.state.arquivo);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.zip_id) ? 'Arquivo enviado com sucesso':

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.produto_id){
                this.props.router.navigate("/base");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao enviar o arquivo, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value, type, files } = e.target;
        this.setState({ [name]: type === 'file' ? files[0] : value });
    };


    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Form onSubmit={this.enviaRegistro}>
                            <h4>Base CRM</h4>
                            <Row>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Arquivo Zip</Form.Label>
                                        <Form.Control type="file" accept=".zip" name="arquivo" value={this.state.arquivo} onChange={this.handleChange} ref={this.fileInput} />
                                        <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.zipHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row> 
                            {this.state.erroLoadRegistro ? 
                            <Alert variant="warning">
                                {this.state.erroLoadRegistro}
                            </Alert> : ''
                            }                                               
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> Salvar
                                    </>
                                )}
                            </Button>
                        </Form> 
                    </Card.Body>                
                </Card>
            </div>
        )
    }
}

export default withRouter(Base);